import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <path d="M3 3v16a2 2 0 0 0 2 2h16"/>
  <rect x="15" y="5" width="4" height="12" rx="1"/>
  <rect x="7" y="8" width="4" height="9" rx="1"/>
</svg>`;

const DataStroke = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='datastroke' svg={svg} {...props} />
  )
);

DataStroke.displayName = 'DataStrokeIcon';

export default DataStroke;
